import { computed } from 'vue-demi';
const {
    rem: { rem }
} = require('@futuweb/fego-bridge');

export default (props) => {
    const cssVar = computed(() => {
        return {
            '--swiper-item-width': `${rem.str(props.swiperWidth)}`,
            '--swiper-item-height': `${rem.str(props.swiperHeight)}`,
            '--card-spacing': `${rem.str(props.cardSpacing)}`,
            '--card-title-color': props.titleColor,
            '--card-desc-color': props.descColor,
            '--card-bg-active-color': props.bgActiveColor
        };
    });

    return {
        cssVar
    };
};
